
import React, { useEffect, useState } from 'react';
import { FcPhoneAndroid } from 'react-icons/fc'
import Flag from 'react-world-flags'
import { toast } from 'react-toastify';

import { hideModal, showModal } from '../../../Utilities/General/BootstrapApi';

import ArgFlag from '../../../Assets/svg/arg.svg'
import ChiFlag from '../../../Assets/svg/chi.svg'
import ColFlag from '../../../Assets/svg/col.svg'

const PRESETS = [
    {
        name: 'Screening',
        skus: ['MODULAR_LICENSE_01']
    },
    {
        name: 'Diagnóstico',
        skus: ['MODULAR_LICENSE_01', 'AUTOMATIC_AND_MANUAL_BONE_TEST_01', 'MANUAL_LOGO_TEST_01']
    },
    {
        name: 'Clínico',
        skus: ['DIAG_LICENSE_01']
    },
    {
        name: 'Clínico + AF',
        skus: [
            'MODULAR_LICENSE_01',
            'AUTOMATIC_AND_MANUAL_BONE_TEST_01',
            'MANUAL_AIR_LOUDNESS_DISCOMFORT_LEVEL_01',
            'MANUAL_SISI_TEST_01',
            'MANUAL_FOWLER_TEST_01',
            'MANUAL_LOGO_TEST_01',
            'MANUAL_TINNITUS_TEST_01',
            'MANUAL_TINNITUS_HANDICAP_TEST_01',
            'MANUAL_HIGH_FREQUENCY_TEST_01',
            'MANUAL_WEBER_TEST_01'
        ],
        discount: 100
    }
]

export default function CreateFreemiumSettings({
    order,
    freemiumArticle,
    clients,
    countries,
    uSoundPaymentOrder,
    setUsoundPaymentOrder,
    paymentServiceProducts,
    shippingData
}) {

    const [freemiumSet, setFreemiumSet] = useState([])

    const [currentCountry, setCurrentCountry] = useState('')

    useEffect(() => {
        setCurrentCountry(countries?.find(country => country.id === parseInt(shippingData.address_country))?.iso_code)
    }, [countries, clients, order, shippingData])

    useEffect(() => {
        let freemiumsForPush = []
        let [freemiumPD] = order.paymentdetail_set.filter(pd => pd.article === freemiumArticle.id)
        if (freemiumPD !== undefined) {
            for (let i = 0; i < freemiumPD.count; i++) {
                freemiumsForPush.push({
                    tag: '#' + (i + 1)
                })
            }
            setFreemiumSet(freemiumsForPush)
        }
    }, [order])

    const ensureModularLicense = (orderDetailSet, tag) => {
        if (orderDetailSet.some(od => od.tag === tag && od.product_sku === 'MODULAR_LICENSE_01')) {
            return orderDetailSet
        }
        let modularProduct = paymentServiceProducts.find(p => p.sku === 'MODULAR_LICENSE_01')
        let modularPricing = modularProduct?.pricing_set.find(ps => ps.country_iso === currentCountry)
        return [
            ...orderDetailSet.filter(od => !(od.tag === tag && od.product_sku === 'DIAG_LICENSE_01')),
            {
                tag,
                pricing: modularPricing?.id || null,
                product_sku: 'MODULAR_LICENSE_01',
                sku: 'MODULAR_LICENSE_01'
            }
        ]
    }

    const handleChange = (e, product_sku, name, tag) => {
        let base = ensureModularLicense(
            uSoundPaymentOrder.orderdetail_set.filter(od => od.tag !== tag || (od.tag === tag && od.product_sku !== product_sku)),
            tag
        )
        if (e.target.value === 'exclude') {
            setUsoundPaymentOrder({
                ...uSoundPaymentOrder,
                orderdetail_set: base
            })
        } else {
            let ps = JSON.parse(e.target.value)
            setUsoundPaymentOrder({
                ...uSoundPaymentOrder,
                orderdetail_set: [
                    ...base,
                    {
                        pricing: parseInt(ps.id),
                        amount: ps.amount,
                        currency: ps.currency,
                        discount: 0,
                        product_sku,
                        name,
                        tag
                    }
                ]
            })
        }
    }

    const resetSelects = (tag = null) => {
        let selects = document.getElementsByClassName(tag === null ? 'freemiumSelects' : 'select' + tag)
        for (let i = 0; i < selects.length; i++) {
            selects[i].value = 'exclude'
        }
    }

    const getIncludedSkus = (tag) => uSoundPaymentOrder.orderdetail_set.filter(od => od.tag === tag).map(od => od.product_sku)

    const getLicenseSku = (tag) => uSoundPaymentOrder.orderdetail_set.find(od => od.tag === tag && od.product_sku?.includes('LICENSE'))?.product_sku

    const isDiagLicenseActive = (tag) => getLicenseSku(tag) === 'DIAG_LICENSE_01'

    const isClinicoAFActive = (tag) => getActivePreset(tag) === 'Clínico + AF'

    const getActivePreset = (tag) => {
        let included = new Set(getIncludedSkus(tag))
        let match = PRESETS.find(preset => {
            let presetSkus = new Set(preset.skus)
            return included.size === presetSkus.size && [...included].every(sku => presetSkus.has(sku))
        })
        return match?.name || 'Personalizado'
    }

    const applyPreset = (preset, tag) => {
        let newEntries = preset.skus.map(sku => {
            let product = paymentServiceProducts.find(p => p.sku === sku)
            let isFeature = product?.type === 'feature'
            let lifetimePricing = isFeature
                ? product.pricing_set.find(ps => ps.country_iso === currentCountry && ps.period === 0)
                : product?.pricing_set.find(ps => ps.country_iso === currentCountry)
            if (!isFeature) {
                return {
                    tag,
                    pricing: lifetimePricing?.id || null,
                    product_sku: sku,
                    sku
                }
            }
            let discount = preset.discount || 0
            let amount = lifetimePricing?.amount !== undefined
                ? (parseFloat(lifetimePricing.amount) - (parseFloat(lifetimePricing.amount) / 100) * discount).toFixed(2)
                : lifetimePricing?.amount
            return {
                tag,
                pricing: lifetimePricing?.id || null,
                amount,
                currency: lifetimePricing?.currency,
                discount,
                product_sku: sku,
                sku,
                name: product?.name
            }
        })

        setUsoundPaymentOrder({
            ...uSoundPaymentOrder,
            orderdetail_set: [
                ...uSoundPaymentOrder.orderdetail_set.filter(od => od.tag !== tag),
                ...newEntries
            ]
        })

        resetSelects(tag)
        paymentServiceProducts
            .filter(p => p.type === 'feature' && preset.skus.includes(p.sku))
            .forEach(p => {
                let select = document.getElementById('freemiumSelect' + p.name + tag)
                let lifetimePricing = p.pricing_set.find(ps => ps.country_iso === currentCountry && ps.period === 0)
                if (select !== null && lifetimePricing) select.value = JSON.stringify(lifetimePricing)

                let rewardedSelect = document.getElementById('freemiumRewardedSelect' + p.name + tag)
                if (rewardedSelect !== null) rewardedSelect.value = String(preset.discount || 0)
            })
    }

    const clearPreset = (tag) => {
        setUsoundPaymentOrder({
            ...uSoundPaymentOrder,
            orderdetail_set: uSoundPaymentOrder.orderdetail_set.filter(od => od.tag !== tag)
        })
        resetSelects(tag)
    }

    const allAudiometersAssigned = () => {
        let flag = true
        freemiumSet.forEach(fs => {
            if (!uSoundPaymentOrder.orderdetail_set.some(od => od.tag === fs.tag)) {
                flag = false
                toast.error(`Elija una licencia para el audiómetro ${fs.tag}`, {
                    position: 'bottom-left',
                    hideProgressBar: true,
                    className: 'error-toast'
                })
            }
        })
        return flag
    }

    const handleChangeRewarded = (e, product_sku, tag) => {
        let pricing = uSoundPaymentOrder.orderdetail_set.find(od => od.tag === tag && od.product_sku === product_sku).pricing
        let base_amount
        paymentServiceProducts.forEach(prod => {
            prod.pricing_set.forEach(ps => {
                if (ps.id === pricing) base_amount = ps.amount
            })
        })
        setUsoundPaymentOrder({
            ...uSoundPaymentOrder,
            orderdetail_set: [
                ...uSoundPaymentOrder.orderdetail_set.filter(od => od.tag !== tag || od.product_sku !== product_sku),
                {
                    ...uSoundPaymentOrder.orderdetail_set.find(od => od.tag === tag && od.product_sku === product_sku),
                    discount: e.target.value,
                    amount: (parseInt(base_amount) - ((parseInt(base_amount) / 100) * parseInt(e.target.value))).toFixed(2)
                }
            ]
        })
    }

    return (
        <div className="modal fade" id="freemiumSettings">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h3 className="modal-title text-info" id="staticBackdropLabel">Configurar Servicios Modular</h3>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={() => {
                                hideModal('freemiumSettings')
                            }}
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className='text-center'>
                            <p>
                                <strong>
                                    Seleccione las evaluaciones incluidas en cada Audiómetro Modular de la orden y sus períodos correspondientes
                                </strong>
                            </p>
                            <p>
                                País:
                                {currentCountry === 'AR' &&
                                    <img src={ArgFlag} width="40" className="ms-2" alt='' />
                                }
                                {currentCountry === 'BO' &&
                                    <Flag code='BO' className='ms-2' width="40" />
                                }
                                {currentCountry === 'BR' &&
                                    <Flag code='BR' className='ms-2' width="40" />
                                }
                                {currentCountry === 'CL' &&
                                    <img src={ChiFlag} width="40" className="ms-2" alt='' />
                                }
                                {currentCountry === 'CO' &&
                                    <img src={ColFlag} width="40" className="ms-2" alt='' />
                                }
                                {currentCountry === 'EC' &&
                                    <Flag code='EC' className='ms-2' width="40" />
                                }
                                {currentCountry === 'PE' &&
                                    <Flag code='PE' className='ms-2' width="40" />
                                }
                            </p>
                        </div>
                        <div className='d-flex flex-wrap justify-content-around'>
                            {freemiumSet.map(fs => {
                                return (
                                    <div className='d-flex flex-column justify-content-center text-center p-3 m-2 rounded shadow-sm'>
                                        <span className='fs-1'>
                                            <FcPhoneAndroid />
                                        </span>
                                        <strong>Audiómetro {fs.tag}</strong>
                                        <div className='border border-muted rounded mt-3 p-3'>
                                            <strong>Presets</strong>
                                            <div className='d-flex flex-wrap justify-content-center gap-2 mt-2'>
                                                {PRESETS.map(preset => {
                                                    let isActive = getActivePreset(fs.tag) === preset.name
                                                    return (
                                                        <button
                                                            key={preset.name}
                                                            type='button'
                                                            className={`btn btn-sm rounded-pill px-3 ${isActive ? 'btn-info text-white' : 'btn-outline-secondary'}`}
                                                            onClick={() => applyPreset(preset, fs.tag)}
                                                        >
                                                            {preset.name}
                                                        </button>
                                                    )
                                                })}
                                                <button
                                                    type='button'
                                                    className={`btn btn-sm rounded-pill px-3 ${getActivePreset(fs.tag) === 'Personalizado' ? 'btn-info text-white' : 'btn-outline-secondary'}`}
                                                    onClick={() => clearPreset(fs.tag)}
                                                >
                                                    Personalizado
                                                </button>
                                            </div>
                                            <div className='mt-2 small text-muted'>
                                                Licencia: <strong>{getLicenseSku(fs.tag) || '-'}</strong>
                                            </div>
                                        </div>
                                        <table id={'features_table_' + fs.tag} className='table table-hover mt-3'>
                                            <thead>
                                                <tr>
                                                    <th>Evaluación</th>
                                                    <th>Período y monto de base</th>
                                                    <th>% bonificación</th>
                                                    <th>Monto</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {paymentServiceProducts
                                                    .filter(p => p.type === 'feature')
                                                    .sort((a, b) => {
                                                        if (a.name > b.name) return 1
                                                        if (b.name > a.name) return -1
                                                        return 0
                                                    })
                                                    .map(p => {
                                                        let od = uSoundPaymentOrder.orderdetail_set.find(od => od.tag === fs.tag && od.product_sku === p.sku)
                                                        return (
                                                            <tr key={p.id}>
                                                                <td>
                                                                    {p.name}
                                                                </td>
                                                                <td>
                                                                    <select
                                                                        id={'freemiumSelect' + p.name + fs.tag}
                                                                        className={`form-select freemiumSelects ${'select' + fs.tag}`}
                                                                        onChange={e => handleChange(e, p.sku, p.name, fs.tag)}
                                                                        disabled={isDiagLicenseActive(fs.tag) || isClinicoAFActive(fs.tag)}
                                                                    >
                                                                        <option value="exclude">
                                                                            {isDiagLicenseActive(fs.tag) && p.sku !== 'MANUAL_HIGH_FREQUENCY_TEST_01' ? 'Ya incluido' : 'No incluido'}
                                                                        </option>
                                                                        {p.pricing_set.sort((a, b) => b.period - a.period).map(ps => {
                                                                            if (ps.country_iso === currentCountry) {
                                                                                return (
                                                                                    <option key={ps.id} value={JSON.stringify(ps)}>
                                                                                        {`${ps.period === 0 ? 'De por vida' : ps.period === 12 ? 'Anual' : ps.period + ' meses'} - ${ps.amount} ${ps.currency}`}
                                                                                    </option>
                                                                                )
                                                                            }
                                                                        })}
                                                                    </select>
                                                                </td>
                                                                <td>
                                                                    <select
                                                                        id={'freemiumRewardedSelect' + p.name + fs.tag}
                                                                        className={`form-select freemiumSelects ${'select' + fs.tag}`}
                                                                        onChange={e => handleChangeRewarded(e, p.sku, fs.tag)}
                                                                        disabled={!od || isDiagLicenseActive(fs.tag) || isClinicoAFActive(fs.tag)}
                                                                    >
                                                                        <option value="0">Sin bonificación</option>
                                                                        {Array.from({ length: 100 })
                                                                            .map((_, idx) => {
                                                                                if ((idx + 1) % 5 === 0) {
                                                                                    return (
                                                                                        <option key={idx} value={idx + 1}>{idx + 1}%</option>
                                                                                    )
                                                                                }
                                                                            })}
                                                                    </select>
                                                                </td>
                                                                <td>
                                                                    {od ? `${od.amount} ${od.currency}` : '-'}
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                            </tbody>
                                        </table>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => {
                                resetSelects()
                                setUsoundPaymentOrder({
                                    orderdetail_set: []
                                })
                            }}
                        >
                            BORRAR DATOS
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => {
                                hideModal('freemiumSettings')
                            }}
                        >
                            VOLVER A LA ORDEN
                        </button>
                        <button
                            type="button"
                            className="btn btn-info text-white"
                            onClick={() => {
                                if (!allAudiometersAssigned()) return
                                hideModal('freemiumSettings')
                                showModal('orderDataConfirm')
                            }}
                        >
                            CONFIRMAR
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}